import { OBSERVATORY, STAGES } from "../enums/Type";

export const isPrivateMode = process.env.VUE_APP_MODE === "private";
export const isPublicMode = !isPrivateMode;

export const ROAD_CAMERAS = ["99_7000_2_1", "99_7000_2_2", "99_7000_2_3"];

export const getStageColor = (stage, cyrrentLevel) => {
  const level = Number(cyrrentLevel);
  if (level === undefined || level === null || isNaN(level)) {
    return STAGES.DEFICIT.color;
  }
  if (stage.type === OBSERVATORY.STAGE_KIKI.code) {
    if (level >= stage.floodLevel) {
      return STAGES.OUTBREAK.color;
    } else if (level >= stage.warnLevel) {
      return STAGES.DANGEROUS.color;
    } else if (level >= stage.startLevel) {
      return STAGES.START.color;
    }
  } else {
    if (level >= stage.outbreakLevel) {
      return STAGES.OUTBREAK.color;
    } else if (level >= stage.dangerousLevel) {
      return STAGES.DANGEROUS.color;
    } else if (level >= stage.evacuationLevel) {
      return STAGES.EVACUATION.color;
    } else if (level >= stage.warningLevel) {
      return STAGES.WARNING.color;
    } else if (level >= stage.standbyLevel) {
      return STAGES.STANDBY.color;
    }
  }
  return STAGES.NORMAL.color;
};

export const getStageChipStyle = (stage, level) => {
  let color = "#fafafa";
  let background = getStageColor(stage, level);
  if (background === STAGES.WARNING.color) {
    color = "#212121";
  } else if (
    background === STAGES.NORMAL.color ||
    background === STAGES.DEFICIT.color
  ) {
    color = "#212121";
    background = "transparent";
  }
  return {
    height: "17px",
    lineheight: "17px",
    padding: "0 6px",
    background: background,
    color: color
  };
};

export const getAlertColor = alertName => {
  if (alertName.includes("特別警報")) {
    return "black";
  } else if (alertName.includes("危険警報")) {
    return "purple";
  } else if (alertName.includes("警報")) {
    return "red";
  } else if (alertName.includes("注意報")) {
    return "warning";
  } else {
    return "gray";
  }
};
